export default "__VITE_ASSET__3dc399c8__"